import { bearerAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import logo from "./logo.svg";

const credential = productVariant({
  authLabel: "Existing access token",
  identifier: "linkedIn",
  protocol: "http",
  defaultUrlPattern: () => "https://api\\.linkedin\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an OAuth 2.0 access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://learn.microsoft.com/en-us/linkedin/shared/authentication/authentication](https://learn.microsoft.com/en-us/linkedin/shared/authentication/authentication) and [https://learn.microsoft.com/en-us/linkedin/shared/authentication/authorization-code-flow](https://learn.microsoft.com/en-us/linkedin/shared/authentication/authorization-code-flow) to create an OAuth 2.0 access token for the LinkedIn API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "OAuth 2.0 access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.linkedin.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.linkedin.com/v2/me")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});

export const linkedIn = defineProduct({
  name: "LinkedIn",
  tagLine: "Professional network APIs",
  logo,
  tags: ["communication"],
  variants: [
    credential,
    productVariant({
      identifier: "linkedInOAuth",
      authLabel: "OAuth",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.linkedin\\.com/.*",
      auth: oauthAuth,
      steps: oauthSetupSteps({
        identifier: "linkedInOAuth",
        registrationUrl: "https://www.linkedin.com/developers/apps",
        scopes: ["openid", "profile"],
        instructions:
          "Enable the Sign In with LinkedIn using OpenID Connect product for your application.",
      }),
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () =>
          "https://www.linkedin.com/oauth/v2/authorization",
        tokenEndpoint: () => "https://www.linkedin.com/oauth/v2/accessToken",
        tokenEndpointAuthMethod: () => "client_secret_post",
        clientCredentialsFrom: "db",
        scopes: () => ["openid", "profile"],
        pkce: () => false,
      },
      connectionTest: {
        protocol: "http",
        request: () => "https://api.linkedin.com/v2/userinfo",
      },
    }),
  ],
});
